import { render, staticRenderFns } from "./EmptyContent.vue?vue&type=template&id=2fee6060&scoped=true"
import script from "./EmptyContent.vue?vue&type=script&lang=js"
export * from "./EmptyContent.vue?vue&type=script&lang=js"
import style0 from "./EmptyContent.vue?vue&type=style&index=0&id=2fee6060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fee6060",
  null
  
)

export default component.exports